/**
 * Retrieves a token from the local storage.
 * @param {string} tokenName - The name of the token to retrieve.
 * @return {Promise<string>} - A promise that resolves with the token value, if it exists.
 *                            Otherwise, it rejects with an error message.
 */
export async function getTokenFromLocalStorage(
  tokenName: string,
): Promise<string> {
  return new Promise((resolve) => {
    if (typeof window !== 'undefined') {
      const token = window.localStorage.getItem(tokenName);
      if (tokenName === 'accessToken' && token === null) {
        return;
      }
      resolve(token as string);
    }
  });
}
